module.exports = "/_next/static/images/banner-mem-f73bf6fddc94f2e923cfebc7bf6e3e7d.jpg";